// A24.22 — Config o'zgarishlar tarixi adapter. Module-local (shared adapters.ts
// ga tegmaydi). Barcha config-mutatsiya (flag/module/system-setting/experiment)
// admin_audit dan config-action lens bilan o'qiladi.
import { api } from '@/lib/api'

export interface ConfigChangeRow {
  id?: number
  admin?: string | null
  action: string
  key?: string | null // audit target (setting/flag key)
  value?: string | null // audit detail (new value)
  ip?: string | null
  created_at: number
}

export interface ConfigHistoryQuery {
  action?: string
  admin?: string
  key?: string
  since?: number
  until?: number
  limit?: number
}

export async function fetchConfigHistory(q: ConfigHistoryQuery): Promise<ConfigChangeRow[]> {
  const r = await api.get<{ items?: ConfigChangeRow[] }>('/admin/config/history', {
    query: {
      action: q.action || undefined,
      admin: q.admin || undefined,
      key: q.key || undefined,
      since: q.since || undefined,
      until: q.until || undefined,
      limit: q.limit ?? 300,
    },
  })
  return r.items ?? []
}

export async function fetchConfigActions(): Promise<string[]> {
  const r = await api.get<{ items?: string[] }>('/admin/config/history/actions')
  return r.items ?? []
}
